import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import {choseCurrencyIndex} from '../action/productAction';
class RedeemCurrencyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }
  componentWillMount() {
    document.title = "选择赎回至"
  }
  changeIndex(item,i){
    this.props.dispatch(choseCurrencyIndex(i))
    hashHistory.goBack()
  }
  render(){
    let {
      dataSouse
    }=this.props.location.state;//nav 传入
    let icon=[require('../img/circleHookG.png'),require('../img/circleHookO.png')];
    let {currencyIndex}=this.props;
    return (
        <div className="container" >
          <NavigatorMain>
          <div className="header black">
            <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
            <div>选择赎回至</div>
            <div></div>
          </div>
          </NavigatorMain>
          <div className='content'>
            {
              dataSouse.map( (item,i)=> {
                return(
                  <div className='currencyList' onClick={()=>this.changeIndex(item,i)}>
                    <div>
                      <div style={{color:'#3a3f47',fontSize:16}}>{item.fundname}{i==0?<div className='znyx'/>:null}</div>
                      <div style={{color:'#5c6470'}}>{item.wanfenshouyi}<div style={{color:'#e64743'}}>{item.qirinianhua}</div></div>
                      <div style={{color:'#a1a7b2'}}>万分收益{item.publish_date.substr(-5)}<div>7日年化收益</div></div>
                    </div>
                    <div className='bankListRightOK'>
                      <img src={currencyIndex===i?icon[1]:icon[0]} className='img'/>
                    </div>
                  </div>
                )
              })
            }      
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    currencyIndex:state.currencyIndex,
  }
}
export default connect(mapStateToProps)(RedeemCurrencyList);



// WEBPACK FOOTER //
// ./src/components/RedeemCurrencyList.js